import { render, staticRenderFns } from "./breadcrumb-item.vue?vue&type=template&id=56fbb3af&scoped=true"
import script from "./breadcrumb-item.ts?vue&type=script&lang=js&external"
export * from "./breadcrumb-item.ts?vue&type=script&lang=js&external"
import style0 from "./breadcrumb-item.less?vue&type=style&index=0&id=56fbb3af&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fbb3af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56fbb3af')) {
      api.createRecord('56fbb3af', component.options)
    } else {
      api.reload('56fbb3af', component.options)
    }
    module.hot.accept("./breadcrumb-item.vue?vue&type=template&id=56fbb3af&scoped=true", function () {
      api.rerender('56fbb3af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/breadcrumb/breadcrumb-item/breadcrumb-item.vue"
export default component.exports